import React, { useState } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";

interface TabGroupProps {
  children: React.ReactNode;
}

export const TabGroup: React.FC<TabGroupProps> = ({ children }) => {
  return <>{children}</>;
};

export const TabName: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => <>{children}</>;

export const TabContent: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => <>{children}</>;

interface CustomTabsProps {
  children: React.ReactNode;
}

const CustomTabs: React.FC<CustomTabsProps> = ({ children }) => {
  const [value, setValue] = useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  const tabs = React.Children.toArray(children)
    .map((child) => {
      if (React.isValidElement(child) && child.type === TabGroup) {
        const groupChildren = React.Children.toArray(child.props.children);

        const tabNameElement = groupChildren.find(
          (el): el is React.ReactElement =>
            React.isValidElement(el) && el.type === TabName
        );

        const tabContentElement = groupChildren.find(
          (el): el is React.ReactElement =>
            React.isValidElement(el) && el.type === TabContent
        );

        return {
          label: tabNameElement?.props.children ?? "Default Label",
          content: tabContentElement?.props.children ?? null,
        };
      }
      return null;
    })
    .filter((tab) => tab !== null);

  return (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={value}
          onChange={handleChange}
          indicatorColor={"primary"}
          aria-label="custom tabs"
        >
          {tabs.map((tab, index) => (
            <Tab
              key={index}
              label={tab?.label || ""}
              sx={{
                fontWeight: value === index ? "bold" : "normal",
              }}
            />
          ))}
        </Tabs>
      </Box>
      {tabs.map((tab, index) => (
        <div
          key={index}
          role="tabpanel"
          hidden={value !== index}
          id={`tabpanel-${index}`}
          aria-labelledby={`tab-${index}`}
        >
          {value === index && <Box>{tab?.content}</Box>}
        </div>
      ))}
    </Box>
  );
};

export default CustomTabs;
